import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import background from "./images/background.jpeg";
import "./App.css";
import CircularProgress from "@mui/material/CircularProgress";
import NEDNavbar from "./components/navbar/NEDNavbar";
import Button from "react-bootstrap/Button";
import Axios from "axios";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";

const App = () => {
  const [modules, setModules] = useState([]);
  const [user, setUser] = useState({
    givenName: "",
    familyName: "",
    userId: "",
    role: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Utente non abilitato");
  const [isLoadingProfile, setIsLoadingProfile] = useState(true);
  const bearerToken = localStorage.getItem("bearerToken");

  const endPointsFile = "/env/endpoints.json";
  const loadEndPoints = () => {
    var queryString = window.location.origin + endPointsFile;
    var req = new XMLHttpRequest();
    req.open("GET", queryString, false);
    req.send();
    let ris = JSON.parse(req.response);
    sessionStorage.setItem("EDOC_PROFILER", ris.EDOC_PROFILER);
    sessionStorage.setItem("EDOC_LOGCONTROL", ris.EDOC_LOGCONTROL);
  };

  const profile = async (token) => {
    const axiosRequest = Axios.create({
      headers: { Authorization: "Bearer " + token },
    });
    let profileServer = sessionStorage.getItem("EDOC_PROFILER");

    const response = await axiosRequest
      .get(profileServer + "/ned/api/profili/me/moduli")
      .catch((error) => {
        if (setError) setError(true);
        if (setErrorMessage)
          setErrorMessage("Impossibile contattare il profiler");
      })
      .then((res) => {
        if (res.data.length < 0) {
          if (setError) setError(true);
          if (setErrorMessage) setErrorMessage("Utente non abilitato");
        } else if (setError) setError(false);
        if (window.location.search.includes("?AI=")) {
          goToUserInterface(res.data);
        }
        setModules(res.data);
      })
      .finally((at) => {
        setIsLoadingProfile(false);
      });
  };

  useEffect(() => {
    loadEndPoints();
    if (isLoadingProfile) {
      profile(bearerToken);
    }
  });

  const parts = bearerToken.split(".");
  const bearerContent = JSON.parse(new Buffer(parts[1], "base64").toString());

  var userFromToken = {
    givenName: bearerContent.given_name,
    familyName: bearerContent.family_name,
    userId: bearerContent.preferred_username.toUpperCase(),
    role: "Consultatore",
  };

  useEffect(() => {
    if (isLoading) {
      setUser(userFromToken);
      if (sessionStorage.getItem("LOGGED") === "OUT") getFromUserInterface();
      else setIsLoading(false);
    }
  }, [isLoading]);

  const goToUserInterface = async (fastModules) => {
    setIsLoadingProfile(true);
    var date = moment().utcOffset("+02:00").format("YYYY-MM-DD HH:mm:ss");
    const formData = new FormData();
    const url =
      sessionStorage.getItem("EDOC_LOGCONTROL") + "/ned/api/gnl/ll/login";
    let method = "POST";
    formData.set("data_operazione", date);
    await Axios({
      url,
      method,
      data: formData,
      headers: {
        Authorization: "Bearer " + bearerToken,
      },
    })
      .catch((error) => {
        setIsLoadingProfile(false);
        //if(setError) setError(true)
        if (setErrorMessage) setErrorMessage("Errore durante il login");
      })
      .finally((end) => {
        setIsLoadingProfile(false);
        if (fastModules !== undefined) {
          console.log("test: " + fastModules[0]);
          if (window.location.search.split("?")[1] !== undefined)
            if (fastModules[0] !== undefined)
              window.open(
                fastModules[0].url +
                  "/ricerche?" +
                  window.location.search.split("?")[1],
                "_self"
              );
            else
              window.open(
                modules[0].url +
                  "/ricerche?" +
                  window.location.search.split("?")[1],
                "_self"
              );
          else {
            if (fastModules[0] !== undefined)
              window.open(fastModules[0].url, "_self");
            else window.open(modules[0].url, "_self");
          }
        } else {
          console.log("test: " + modules);
          if (window.location.search.split("?")[1] !== undefined)
            window.open(
              modules[0].url +
                "/ricerche?" +
                window.location.search.split("?")[1],
              "_self"
            );
          else window.open(modules[0].url, "_self");
        }
        sessionStorage.setItem("LOGGED", "IN");
      });
  };

  const getFromUserInterface = async () => {
    var date = moment().utcOffset("+02:00").format("YYYY-MM-DD HH:mm:ss");
    const formData = new FormData();
    const url =
      sessionStorage.getItem("EDOC_LOGCONTROL") + "/ned/api/gnl/ll/logout";
    let method = "POST";
    formData.set("data_operazione", date);
    await Axios({
      url,
      method,
      data: formData,
      headers: {
        Authorization: "Bearer " + bearerToken,
      },
    })
      .then((res) => {
        setIsLoading(false);
        sessionStorage.removeItem("LOGGED");
      })
      .catch((error) => {
        setIsLoading(false);
        sessionStorage.removeItem("LOGGED");
        //if(setError) setError(true)
        if (setErrorMessage)
          setErrorMessage("Errore durante la validazione delle credenziali");
      });
  };

  return (
    <>
      <NEDNavbar user={user} />
      <div className="div-container-login">
        <div className="wrap-login">
          <div className="login-form">
            <div className="text-style-title text-center">
              Ciao {user.givenName}
            </div>
            <div className="text-center text-primary">
              {!isLoadingProfile ? (
                !error && modules.length > 0 ? (
                  <Button
                    onClick={goToUserInterface}
                    className="button-primary mt-4"
                  >
                    Accedi
                  </Button>
                ) : !errorMessage.includes("credenziali") ? (
                  <>
                    <h4>
                      {" "}
                      <IconButton
                        onClick={goToUserInterface}
                        className="text-primary"
                      >
                        <ReplayOutlinedIcon />
                      </IconButton>{" "}
                    </h4>
                    <h4> {errorMessage} </h4>
                  </>
                ) : !errorMessage.includes("profiler") ? (
                  <>
                    <h4>
                      {" "}
                      <IconButton
                        onClick={() => profile(bearerToken)}
                        className="text-primary"
                      >
                        <ReplayOutlinedIcon />
                      </IconButton>{" "}
                    </h4>
                    <h4> {errorMessage} </h4>
                  </>
                ) : (
                  <>
                    <h4>
                      {" "}
                      <IconButton
                        onClick={getFromUserInterface}
                        className="text-primary"
                      >
                        <ReplayOutlinedIcon />
                      </IconButton>{" "}
                    </h4>
                    <h4> {errorMessage} </h4>
                  </>
                )
              ) : (
                <CircularProgress />
              )}
            </div>
          </div>
          <div className="login-image">
            <img className="image-style-portal" src={background} />
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
